<template lang="html">
  <article class="workItem" :class="type === 'video' ? 'workItem--video' : ''" @click="selectWork" :id="id">
    <div class="workItem__image" :style="{ backgroundImage: `url(${image})` }"></div>
    <h3 class="workItem__label">{{ label }}</h3>
    <p class="workItem__tag">{{ tag }}</p>
  </article>
</template>

<script>
export default {
  name: 'WorkItem',
  props: ['image', 'label', 'tag', 'id', 'type'],
  methods: {
    selectWork(event) {
      const target = event.currentTarget;
      const group = this.type === 'video' ? 'worksLongFormat' : 'works'
      this.$store.commit('changeSelectedWork', { group, id: this.id });
      this.$store.commit('openVideo', { group, id: this.id });
    }
  }
}
</script>

<style lang="scss">
@import "../styles/config.scss";

.workItem {
  &:after {
    content: 'play';
    font-family: CamptonBold;
    color: var(--Neu01);
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%) scale(.5);
    border: 1px solid var(--M01);
    border-radius: 50%;
    padding: 80px 75px;
    pointer-events: none;
    opacity: 0;
    transition: all .3s cubic-bezier(.41, .15, .41, 1.31);
  }

  &:hover {
    &:after {
      opacity: 1;
      transform: translateX(-50%) scale(1);
    }
  }

  &__image {
    height: 200px;
    // max-width: 360px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    overflow: hidden;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: block;
      background-color: rgba(0, 0, 0, .3);
    }
  }

  &__label {
    font-family: CamptonBold;
    font-size: 16px;
    color: var(--Neu01);
    margin-top: 20px;
    margin-bottom: 5px;
  }

  &__tag {
    font-family: CamptonBook;
    font-size: 16px;
    line-height: 1.13;
    color: var(--Neu07);
  }

  &--video {
    .workItem__image {
      height: 500px;
    }

    &:after {
      top: 150px;
    }
  }

  @include mq(0, 1024px) {
    &:after {
      padding: 60px 55px;
    }

    &__label {
      margin-top: 10px;
      margin-bottom: 5px;
    }
  }

  // TODO: VER ISTO
  @include mq(0, 768px) {
    &:after {
      padding: 60px 55px;
    }
  }

  @include mq(0, 768px) {
    &:after {
      top: 15px;
      padding: 70px 65px;
    }

    &--video:after {
      top: 160px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WorkItem.vue